import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { SelectFilter } from './Filters/SelectFilter.js';
import { useBreakpointRef } from '../hooks/useBreakpointRef.js';
var SidebarSwitcher = function SidebarSwitcher(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    options = _ref.options,
    onChange = _ref.onChange;
  if (!options) return null;
  var BREAKPOINTS = Object.freeze([1080]);
  var BREAKPOINT_VALUES = Object.freeze([true, false]);
  var _useBreakpointRef = useBreakpointRef({
      breakpoints: BREAKPOINTS,
      breakpointValues: BREAKPOINT_VALUES,
      direction: ''
    }),
    breakpointValue = _useBreakpointRef.breakpointValue;
  return /*#__PURE__*/React.createElement("div", {
    className: "sidebar-role-switcher"
  }, /*#__PURE__*/React.createElement(SelectFilter, _extends({
    defaultValue: options[0],
    isClearable: false
  }, breakpointValue ? {
    size: 'xs'
  } : {}, {
    name: "option_switcher",
    iconKey: "icon",
    label: label,
    onChange: onChange,
    options: options,
    labelKey: "label",
    explainerKey: "description"
  })));
};
SidebarSwitcher.displayName = "SidebarSwitcher";
SidebarSwitcher.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func
};
export { SidebarSwitcher };